import { PageMetaInterface } from './page-meta.interface';

export interface PageInterface<T> {
  results: T[];
  pagination: PageMetaInterface;
  totalElements: number;
}
